/* global Search */

if (document.querySelector(".fbjs-search--financial-news")) {
    window.searchFinancialNewsLanding = new Search.default({
        url: "https://dxp-uk-search.funnelback.squiz.cloud/s/search.json",
        collections: ["push-wood-financial-news"],
        additionalFBparams: {
            profile: "_default"
        },
        shouldFacetsFromUrlOverwriteActiveFacets: true,
        results: {
            numRanks: 12,
        },
        sort: {
            type: "date",
        },

        pagination: {
            loadMore: false,
            arrows: true,
            arrowsOnEdgePages: true,
            dots: false,
            edgePages: true,
            pages: 0,
        },

        templates: {

            articleTemplate: (fields) => {

                // 2017-08-10 -> 10 Aug 2017
                const changeDate = () => {
                    const monthArray = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                        ],
                        // dateFromFunnelback = fields.metaData.d, // 2017-08-10
                        splitedDate = fields.metaData.d.split("-");

                    return `${splitedDate[2]} ${
                        monthArray[Number(splitedDate[1]) - 1]
                    } ${splitedDate[0]}`;
                };

                return `<div class="news-card__wrapper static-size-12">
                            <a href="https://wood-search01.squiz.co.uk${fields.clickTrackingUrl}">
                                <div class="news-card__content no-gutters">
                                    <div class="date">${changeDate()}</div>
                                    <p class="title truncate-lines-2 secondary-link">
                                    ${fields.metaData.t}
                                    </p>
                                </div>
                            </a>
                        </div>`;
            },

            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: (fields, resultsSummary) => {
                return `
                    <p>
                      showing <strong>${resultsSummary.currStart}-${resultsSummary.currEnd} of ${resultsSummary.totalMatching}</strong> results
                    </p>
                  `;
            },

            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                <div class="search-field">
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Search Investor News"
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                </div>
                `;
            },

            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startrank
             * @returns {string}
             **/
            paginationNumberTemplate: (number, startrank) => {
                if (startrank === 1) {
                    return ''
                }
                return `<li data-startrank=${startrank} tabindex="0">${number}</li>`;
            },

            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/
            activePaginationNumberTemplate: (number) => {
                return `<li class="active-page">${number}/</li>`;
            },

            /**
             * @name paginationTemplate
             * @param pages
             * @returns {string}
             **/
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },

            arrowNextTemplate: (startrank) => {
                if (startrank) {
                    return `<button class="next-page" tabindex="0" data-startrank=${startrank}>Next</button>`;
                }

                return '<button class="next-page disabled" tabindex="0">Next</button>';
            },

            arrowPrevTemplate: (startrank) => {
                if (startrank) {
                    return `<button class="prev-page" tabindex="0" data-startrank=${startrank}>Previous</button>`;
                }

                return '<button class="prev-page disabled" tabindex="0">Previous</button>';
            },

            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                return "<div>We're sorry, we couldn't find anything matching.</div>";
            },
        },
    });

    window.searchFinancialNewsLanding.init();
}
